import AuthLayout from '@/components/Layout/AuthLayout'
import { Button, Flex, Heading, VStack } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'

const ErrorPage = () => {
  const { t } = useTranslation()

  return (
    <AuthLayout title={'Error'}>
      <VStack h="100vh" w="100vw" role="alert" justifyContent="center" alignItems="center" spacing="20px">
        <Heading size="lg" color={'white'}>
          {t('ERROR_PAGE_WARNING')}
        </Heading>
        <Flex w="200px">
          <Button colorScheme="blue" onClick={() => window.location.reload()}>
            {t('ERROR_PAGE_REFRESH')}
          </Button>
        </Flex>
      </VStack>
    </AuthLayout>
  )
}

export default ErrorPage
